export const filteredSegmentOptions = [
  { key: 'all', value: 'all', text: 'All Segments' },
  { key: 'advertiser_id', value: 'advertiser_id', text: 'Advertiser Segments' },
];

export const bidFormKeys = ['startingMinBid', 'startingMaxBid', 'maxDays'];
